import React from 'react';
import BarcodeScanner from './BarcodeScannerComponent';

function App() {
  return (
    <div className="App">
      <h1>React Készletkezelő Vonalkód-olvasó</h1>
      <BarcodeScanner />
    </div>
  );
}

export default App;
